import { AttrKeys } from '@sharedModule/constants/fields.constant';

export const UPSERT_USER_ATTRIBUTES_CONSTANT = {
  userType: {
    type: 'text',
    key: 'role_type',
    label: 'User Type',
  },
  partner: {
    type: 'select',
    key: 'partner_id',
    label: 'Partner',
  },
  firstName: {
    type: 'text',
    key: 'first_name',
    label: 'First Name',
  },
  lastName: {
    type: 'text',
    key: 'last_name',
    label: 'Last Name',
  },
  nationality: {
    type: 'select',
    key: 'nationality',
    label: 'Country',
  },
  gender: {
    type: 'select',
    key: 'gender',
    label: 'Gender',
  },
  dob: {
    type: 'date',
    key: 'date_of_birth',
    label: 'Date Of Birth',
  },
  email: {
    type: 'email',
    key: 'email',
    label: 'Email',
  },
  countryCode: {
    type: 'text',
    key: 'country_code',
  },
  mobileNumber: {
    type: 'tel',
    key: 'mobile_number',
    label: 'Phone Number',
  },
  roleId: {
    type: 'select',
    key: 'role_id',
    label: 'Role',
  },
  password: {
    type: 'password',
    key: 'password',
    label: 'Password',
  },
  address1: {
    type: 'text',
    key: 'address1',
    label: 'Address 1',
  },
  address2: {
    type: 'text',
    key: 'address2',
    label: 'Address 2',
  },
  city: {
    type: 'text',
    key: 'city',
    label: 'City',
  },
  postalCode: {
    type: 'text',
    key: 'postal_code',
    label: 'Postal Code',
  },
  isMFADisabled: {
    type: 'radio',
    key: 'is_mfa_disabled',
    label: 'Is MFA Disabled?',
  },
} as const;

export const UPSERT_USER_MESSAGE_CONSTANT = {
  [UPSERT_USER_ATTRIBUTES_CONSTANT.mobileNumber.key as AttrKeys]: {
    pattern: 'Please enter valid mobile number',
    confirmPasswordValidator: '',
  },
};

export const BOOLEAN_OPTION = [
  { value: true, viewValue: 'True' },
  { value: false, viewValue: 'False' },
];
